export const isRechargeLotteryInfoRefreshTrade = (tradeModeCode?: string) =>
  tradeModeCode === "RECHARGE" ||
  tradeModeCode === "GMARTIFICIAL" ||
  !!tradeModeCode?.startsWith("RECHARGE_");

export const isRechargePaymentSuccessTrade = isRechargeLotteryInfoRefreshTrade;
